export const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'navigation':
      return {
        ...state,
        navigation: !state.navigation,
      };
    case 'login':
      return {
        ...state,
        login: !state.login,
      };
    case 'createAccount':
      return {
        ...state,
        createAccount: !state.createAccount,
      };
    case 'newVersion':
      return {
        ...state,
        newVersion: !state.newVersion,
      };
    case 'privacyTermsAcceptance':
      return {
        ...state,
        privacyTermsAcceptance:
          action.payload !== undefined
            ? action.payload
            : !state.privacyTermsAcceptance,
      };
    default:
      return state;
  }
};

export const initialState = {
  navigation: false,
  login: false,
  newVersion: false,
  createAccount: false,
  privacyTermsAcceptance: false,
};
